import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creditclanproducts',
  templateUrl: './creditclanproducts.component.html',
  styleUrls: ['./creditclanproducts.component.css']
})
export class CreditclanproductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
